import {
  IConfigurationParams,
  ConfigurationNames,
} from '../../../../graphql/configuration/models/configuration.models';

export interface IYandexMapStyleConfig {
  styleUpdatedAt?: string;
}

export const getYandexMapStyle = (
  configuration: IConfigurationParams[],
): string | null => {
  const mapStyleParams = configuration.find(
    (params) => params.name === ConfigurationNames.yandexMaps,
  );

  if (mapStyleParams) {
    try {
      const config = JSON.parse(mapStyleParams.configuration);
      return config['style-updated-at'] || null;
    } catch (error) {
      return null;
    }
  }

  return null;
};
